import { useScrollProgress } from './hooks/useScrollProgress.js';
import ScrollProgress from './components/ScrollProgress.jsx';
import Navbar from './components/Navbar.jsx';
import Hero from './components/Hero.jsx';
import About from './components/About.jsx';
import StatsBand from './components/StatsBand.jsx';
import Services from './components/Services.jsx';
import WhyUs from './components/WhyUs.jsx';
import Testimonials from './components/Testimonials.jsx';
import Faq from './components/Faq.jsx';
import Branches from './components/Branches.jsx';
import Team from './components/Team.jsx';
import CtaBand from './components/CtaBand.jsx';
import Contact from './components/Contact.jsx';
import Footer from './components/Footer.jsx';

export default function App() {
  const { progress, scrolled } = useScrollProgress();

  return (
    <>
      <ScrollProgress progress={progress} />
      <Navbar scrolled={scrolled} />
      <main id="main">
        <Hero />
        <About />
        <StatsBand />
        <Services />
        <WhyUs />
        <Testimonials />
        <Faq />
        <Branches />
        <Team />
        <CtaBand />
        <Contact />
      </main>
      <Footer />
    </>
  );
}
